<template>
  <div class="bind_wrapper">
    <van-sticky>
      <van-tabs v-model="active">
        <van-tab
          :title="item.name"
          v-for="item in storeType"
          :key="item.value"
        ></van-tab>
      </van-tabs>
    </van-sticky>

    <div class="bind_body">
      <div v-if="storeListData.length > 0">
        <div v-for="item in storeListData" :key="item.id" class="store_item">
          <div class="top">
            <div class="name">{{ item.shopName }}</div>
            <div class="desc">
              <div class="time">
                到期截止时间:{{ getDate(item.refreshExpiresIn) }}
                <span
                  v-if="item.refreshExpiresIn < new Date().getTime()"
                  class="timeout"
                  >授权过期</span
                >
              </div>
              <div class="auto">
                <span>自动发货</span>
                <van-switch
                  @change="handleAutoDispatch(item)"
                  v-model="item.autoSend"
                  size="14px"
                  active-color="#f93244"
                  inactive-color="#e5e5e5"
                />
              </div>
            </div>
          </div>
          <div class="btn">
            <div class="removebind" @click="cancelBind(item)">解除绑定</div>
            <div class="rebind" @click="reBind(item)">重新绑定</div>
          </div>
        </div>
      </div>
      <van-empty v-else description="暂无数据" />
      <div
        class="add_btn"
        @click="handleBindStore"
        v-show="storeType[active].name != '阿里巴巴'"
      >
        新增店铺
      </div>
      <div
        @click="toOrderApply"
        class="order_link"
        v-if="storeType[active].name != '阿里巴巴' && !payUser"
      >
        订购链接
      </div>
    </div>
  </div>
</template>

<script>
import { storeList, storeUpdate, storeDelete, accountGet } from '@/api';
import { formatDate, getDate, arrNewSet } from '@/utils/util';
export default {
  watch: {
    active: {
      handler(newVal) {
        this.storeListData = [];
        this.getStoreList();
      },
      immediate: true,
      deep: true
    }
  },
  mounted() {
    accountGet().then((res) => {
      this.payUser = res.data.pay;
    });
  },
  data() {
    return {
      payUser: false,
      active: Number(this.$route.query.index) || 0,
      checked: false,
      storeType: [
        {
          value: 'TAOBAO',
          name: '淘宝',
          url:
            'https://oauth.taobao.com/authorize?response_type=token&client_id=12443971&redirect_uri=http://wxnew.lingyunwl.net/ydwd_webpc/redirect.php&state=czkj2_lpw_' +
            window.location.origin.split('//')[1],
          toorder:
            'https://fuwu.taobao.com/ser/detail.htm?service_code=ts-24066'
        },
        {
          value: 'ALIBABA',
          name: '阿里巴巴',
          url:
            'https://auth.1688.com/oauth/authorize?client_id=1926419&site=1688&redirect_uri=https://auth.czkj.cn/alibaba&state=cz_lpw_' +
            window.location.origin.split('//')[1]
        },
        {
          value: 'PDD',
          name: '拼多多',
          url:
            'https://fuwu.pinduoduo.com/service-market/auth?client_id=3e6fe7aadb4748d982cc909394e03efd&redirect_uri=http%3A%2F%2Fpdd.lipw.cn%2F&response_type=code&state=cz_lpw_' +
            window.location.origin.split('//')[1],
          toorder:
            'https://fuwu.pinduoduo.com/service-market/service-detail?detailId=30607'
        },
        {
          value: 'DOUYIN',
          name: '抖音',
          url:
            'https://fuwu.jinritemai.com/authorize?service_id=211&state=cz_lpw_' +
            window.location.origin.split('//')[1],
          toorder:
            'https://fuwu.jinritemai.com/detail?from=fuwu_market_tab&service_id=211'
        }
      ],
      loading: false,
      finished: false,
      list: [],
      page: {
        pageNum: 1,
        pageSize: 20
      },

      storeListData: []
    };
  },

  methods: {
    formatDate,
    getDate,
    arrNewSet,
    getStoreList() {
      this.storeListData = [];
      const params = { type: this.storeType[this.active].value };
      storeList(params).then((res) => {
        if (res.success) {
          this.storeListData = this.arrNewSet(res.data.list);
        } else {
          this.$toast.fail(res.msg);
        }
      });
    },
    handleAutoDispatch(record) {
      storeUpdate('autoSend', {
        autoSend: record.autoSend,
        id: record.id
      }).then((res) => {
        if (res.success) {
          record.autoSend = record.autoSend;
          this.$toast.success('操作成功');
        } else {
          this.$toast.fail(res.msg);
        }
      });
    },
    cancelBind(record) {
      storeDelete(record.id).then((res) => {
        if (res.success) {
          this.$toast.success('解绑成功');
          this.getStoreList();
        } else {
          this.$toast.fail(res.msg);
        }
      });
    },
    reBind(item) {
      //重新绑定要根据店铺类型
      if (item.type == 'FW199-TAOBAO') {
        window.open(
          'https://tb.fw199.com/partner/grant?appid=aXkKJqVn7tYrib0v&callback=' +
            window.location.origin +
            '/fwtaobao'
        );
      } else {
        let type = this.storeType[this.active];
        window.open(type.url);
      }
    },
    handleBindStore() {
      const type = this.storeType[this.active].value;
      //新用户绑定新连接
      if (type == 'TAOBAO' && !this.payUser) {
        window.open(
          'https://tb.fw199.com/partner/grant?appid=aXkKJqVn7tYrib0v&callback=' +
            window.location.origin +
            '/fwtaobao'
        );
      } else {
        window.open(this.storeType[this.active].url);
      }
    },
    toOrderApply() {
      let type = this.storeType[this.active];
      window.open(type.toorder);
    }
  }
};
</script>
<style lang="less" scoped>
/deep/ .van-list__finished-text {
  background-color: #f7f8fa;
}
.bind_wrapper {
  min-height: 100vh;
  background-color: #f7f8fa;
}
.bind_body {
  padding: 0 3.2vw;
}
.store_item {
  background: #ffffff;
  padding: 4.267vw 3.2vw 3.2vw;
  border-radius: 2.133vw;
  margin-top: 3.2vw;

  .top {
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);

    .name {
      margin-bottom: 6.4vw;
      font-size: 4.533vw;
    }

    .desc {
      margin-bottom: 3.2vw;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .time {
        font-size: 3.2vw;
        color: #999999;
      }
      .timeout {
        font-size: 3.2vw;
        color: red;
      }

      .auto {
        display: flex;
        align-items: center;
        span {
          margin-right: 3.2vw;
          font-size: 3.2vw;
          color: #999999;
        }
      }
    }
  }

  .btn {
    display: flex;
    justify-content: flex-end;
    padding: 3.2vw;
    padding-bottom: 0;
    .removebind,
    .rebind {
      width: 25.6vw;
      height: 8.533vw;
      font-size: 3.733vw;
      border-radius: 4.267vw;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .removebind {
      border: 1px solid #dcdee0;
      color: rgba(0, 0, 0, 0.65);
      margin-right: 3.2vw;
    }

    .rebind {
      border: 1px solid #f93244;
      color: #f93244;
    }
  }
}
.add_btn {
  margin-top: 47.333vw;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 11.733vw;
  background: #f93244;
  color: #fff;
  font-size: 4.533vw;
  border-radius: 5.867vw;
}
.order_link {
  margin-top: 3.2vw;
  margin-bottom: 13.333vw;
  color: #f93244;
  text-align: center;
  font-size: 3.733vw;
}
</style>
